import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

import { authGuard, guestGuard } from '@core';
import { areaDashboardGuard } from './dashboard/area-dashboard/area-dashboard.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@theme/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'dashboard/:area',
        canMatch: [areaDashboardGuard],
        loadComponent: () =>
          import('./dashboard/area-dashboard/area-dashboard.component').then(m => m.AreaDashboardComponent),
      },
      {
        path: '403',
        loadComponent: () => import('./sessions/403.component').then(m => m.Error403Component),
      },
      {
        path: '404',
        loadComponent: () => import('./sessions/404.component').then(m => m.Error404Component),
      },
      {
        path: '500',
        loadComponent: () => import('./sessions/500.component').then(m => m.Error500Component),
      },
      {
        path: 'members',
        loadChildren: () => import('./members/members.module').then(m => m.MembersModule),
      },
      {
        path: 'invoices',
        loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule),
      },
      {
        path: 'bookkeeping',
        loadChildren: () => import('./bookkeeping/bookkeeping.routes').then(m => m.BOOKKEEPING_ROUTES),
      },
      {
        path: 'sections',
        loadChildren: () => import('./sections/sections.module').then(m => m.SectionsModule),
      },
      {
        path: 'teams',
        loadChildren: () => import('./teams/teams.module').then(m => m.TeamsModule),
      },
      {
        path: 'sponsors',
        loadChildren: () => import('./sponsors/sponsors.module').then(m => m.SponsorsModule),
      },
      { path: 'news', loadChildren: () => import('./news/news.module').then(m => m.NewsModule) },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
      },
      {
        path: 'website',
        loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule),
      },
      {
        path: 'configurations',
        loadChildren: () =>
          import('./configurations/configurations.module').then(m => m.ConfigurationsModule),
      },
      {
        path: 'accounts',
        loadChildren: () => import('./accounts/account.module').then(m => m.AccountModule),
      },
      {
        path: 'board-administration',
        loadChildren: () =>
          import('./board-administration/board-administration.routes').then(m => m.BOARD_ADMINISTRATION_ROUTES),
      },
      {
        path: 'honors',
        loadChildren: () => import('./honors/honors.routes').then(m => m.HONORS_ROUTES),
      },
      {
        path: 'board',
        loadChildren: () => import('./board/board.module').then(m => m.BoardModule),
      },
      {
        path: 'occupancy',
        loadChildren: () => import('./occupancy/occupancy.routes').then(m => m.OCCUPANCY_ROUTES),
      },
      {
        path: 'member',
        loadChildren: () =>
          import('./member-portal/member-portal.module').then(m => m.MemberPortalModule),
      },
    ],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('@theme/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('./sessions/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./sessions/forgot-password/forgot-password.component').then(
            m => m.ForgotPasswordComponent
          ),
      },
      {
        path: 'reset-password/:token',
        loadComponent: () =>
          import('./sessions/reset-password/reset-password.component').then(
            m => m.ResetPasswordComponent
          ),
      },
    ],
  },
  {
    path: 'public',
    loadComponent: () =>
      import('@theme/public-layout/public-layout.component').then(m => m.PublicLayoutComponent),
    children: [
      {
        path: 'application',
        loadComponent: () =>
          import('./_public/application/application.component').then(m => m.ApplicationComponent),
      },
      {
        path: 'section-application',
        loadComponent: () =>
          import('./_public/section-application/section-application.component').then(m => m.SectionApplicationComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(
      routes,
      {
        useHash: environment.useHash,
      }
    )
  ],
})
export class RoutesRoutingModule {}
